.frame {
  display: block;
  width: 100%;
  border: 1px solid var(--border);
  border-radius: 0.375rem;
  background: var(--surface-raised);
}
